
import {gql} from '@apollo/client';

export const ASSISTANT_LOGS = gql`
  query AssistantLogs($page: Int!) {
    assistantLogs (page: $page) {
      _id
      items {
        _id
        service
        serviceName
        actions
        category
        reason
        from
        subject
        feedback
        created
      }
    }
  }
`;

export const LOGS_GIVE_FEEDBACK = gql`
  mutation AssistantActionGiveFeedback($feedback: String!, $id: ID!) {
    assistantActionGiveFeedback(feedback: $feedback, id: $id)
  }
`;
